<template>
  <TroodonNav>エラー</TroodonNav>
  <TroodonMain>
    <div class="c-error">
      <h2 class="c-error__title">{{ statusMessage }}</h2>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p class="c-error__body" v-html="props.error?.message" />
    </div>
  </TroodonMain>
</template>

<script setup lang="ts">
import '~/styles/troodon/_variables.scss'
import type { NuxtError } from '#app'
import { computed } from 'vue'
import TroodonMain from '~/components/troodon/troodon-main.vue'
import TroodonNav from '~/components/troodon/troodon-nav.vue'

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})

const defaultStatusMessage = computed(() => {
  switch (props.error.statusCode) {
    case 408:
      return 'タイムアウトしました。'
    case 409:
      return 'リクエストが競合しました。'
    case 118:
      return 'リクエストが無効です。'
    default:
      return 'エラーが発生しました。'
  }
})
const statusMessage = computed(() => props.error.statusMessage || defaultStatusMessage.value)
</script>

<style scoped lang="scss">
.c-error {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px 0;
  text-align: center;
}

.c-error__title {
  margin: 0;
  color: var(--troodon-c-text-high);
  font-size: var(--troodon-f-size-lg);
  font-weight: 700;
  line-height: var(--troodon-lh-button);
}

.c-error__body {
  margin: 0;
  color: var(--troodon-c-text-low);
  font-size: var(--troodon-f-size-sm);
  font-weight: 400;
  line-height: var(--troodon-lh-input);
}
</style>
